import React from "react";
import style from './sortFilterButton.module.scss';

const SortFilterButton = (props) => {
    return (
        <div className={style.wrapper}>
            <div className={style.twinButtonWrapper}>
                {
                    props.filters && props.filters.map((item, index) => {
                        return <div
                            key={index}
                            className={props.selected === item.value ? style.selected : style.filter}
                            onClick={() => props.onclick(props.tag, item.value)}
                        >
                            {item.label}
                        </div>
                    })
                }

            </div>
            <div className={style.label}>
                {props.label}
            </div>
        </div>
    )
}
export default SortFilterButton

